//CAN FUNCTION IS PROMISE FUNCTION
import rules from "../rules";

var check = function check(rules, role, action, data) {
  var permissions = rules[role];

  if (!permissions) {
    // role is not present in the rules
    return false;
  }

  var staticPermissions = permissions["static"];

  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true;
  }

  var dynamicPermissions = permissions.dynamic;

  if (dynamicPermissions) {
    var permissionCondition = dynamicPermissions[action];

    if (!permissionCondition) {
      // dynamic rule not provided for action
      return false;
    }

    return permissionCondition(data);
  }

  return false;
};

var canFunction = function canFunction(props) {
  return check(rules, props.role, props.perform, props.data) ? Promise.resolve() : Promise.reject();
};

export default canFunction;